import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';

import PropTypes from 'prop-types';

export default class PrintComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loaded: false,
    };
  }

  render() {
    const { firstName, lastName, appId } = this.props;
    const { loaded } = this.state;

    return (
      <div>
        <div
          style={{
            backgroundColor: '#FFF',
            width: '100%',
            height: '100%',
            position: 'absolute',
          }}
          id="printCover"
        />
        <img
          src={`https://cms.travpromobile.com/api/app/diploma/?first_name=${firstName}&last_name=${lastName}&app_id=${appId}`}
          alt={`${firstName} ${lastName}`}
          width="100%"
          height="auto"
          onLoad={() => {
            window.print();
            setTimeout(() => {
              this.setState({ loaded: true });
            }, 1000);
          }}
        />
        {loaded && <Redirect to="/main/training" />}
      </div>
    );
  }
}

PrintComponent.propTypes = {
  firstName: PropTypes.string.isRequired,
  lastName: PropTypes.string.isRequired,
  appId: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]).isRequired,
};
